module.exports = __webpack_public_path__ + "src/assets/img/m-7.081f3caa.svg";